import { render } from "./CompanionAppHighlight.vue?vue&type=template&id=45855bcc&scoped=true"
import script from "./CompanionAppHighlight.vue?vue&type=script&lang=js"
export * from "./CompanionAppHighlight.vue?vue&type=script&lang=js"

import "./CompanionAppHighlight.vue?vue&type=style&index=0&id=45855bcc&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45855bcc"]])

export default __exports__